import React from "react";
import "./footerMultiLocation.css";
import { icons } from "../../../../svg";

export type FooterItemType = "account" | "origins" | "quote" | null;

interface FooterMultiLocationProps {
  selected: FooterItemType;
  onSelect: (item: FooterItemType) => void;
}

const FooterMultiLocation: React.FC<FooterMultiLocationProps> = ({
  selected,
  onSelect,
}) => {
  const handleSelect = (
    item: FooterItemType,
    e?: React.MouseEvent | React.KeyboardEvent,
  ) => {
    e?.preventDefault();
    e?.stopPropagation();
    onSelect(item);
  };

  const handleKeyDown = (e: React.KeyboardEvent, item: FooterItemType) => {
    if (e.key === "Enter" || e.key === " ") {
      handleSelect(item, e);
    }
  };

  // const groupGlassStyle: React.CSSProperties = {
  //   backgroundColor: "rgba(255, 255, 255, 0.25)",
  //   backdropFilter: "blur(2px)",
  //   WebkitBackdropFilter: "blur(2px)",
  //   border: "1px solid rgba(255, 255, 255, 0.3)",
  // };

  // const quoteGlassStyle: React.CSSProperties = {
  //   backgroundColor: "rgba(255, 255, 255, 0.4)",
  //   backdropFilter: "blur(2px)",
  //   WebkitBackdropFilter: "blur(2px)",
  //   border: "1px solid rgba(255, 255, 255, 0.4)",
  // };

  const groupGlassStyle: React.CSSProperties = {
    backgroundColor: "rgba(255, 255, 255, 0.15)", // Thinned for better clarity
    backdropFilter: "blur(3px) saturate(160%)",
    WebkitBackdropFilter: "blur(4px) saturate(160%)",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.15)",
  };

  const quoteGlassStyle: React.CSSProperties = {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    backdropFilter: "blur(3px) brightness(1.1)",
    WebkitBackdropFilter: "blur(4px) brightness(1.1)",
    border: "1px solid rgba(255, 255, 255, 0.4)",
  };

  const selectedItemStyle: React.CSSProperties = {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  };

  return (
    <div id="footer-multi-location-container" className="fml-container">
      <div className="fml-tab-group" style={groupGlassStyle}>
        <div
          id="footer-multi-location-account-id"
          className={`fml-tab-item ${selected === "account" ? "selected" : ""}`}
          role="button"
          tabIndex={0}
          onClick={(e) => handleSelect("account", e)}
          onKeyDown={(e) => handleKeyDown(e, "account")}
          style={{
            ...(selected === "account" ? selectedItemStyle : {}),
            color: selected === "account" ? "#1D4ED8" : "#000000",
          }}
        >
          <icons.AccountIcon
            className="fml-icon"
            style={{ width: "24px", height: "24px" }}
          />
          <span
            className={`fml-text ${selected === "account" ? "selected" : ""}`}
            style={{ color: selected === "account" ? "#1D4ED8" : "#000000" }}
          >
            Account
          </span>
        </div>

        <div
          id="footer-multi-location-origins-id"
          className={`fml-tab-item ${selected === "origins" ? "selected" : ""}`}
          role="button"
          tabIndex={0}
          onClick={(e) => handleSelect("origins", e)}
          onKeyDown={(e) => handleKeyDown(e, "origins")}
          style={{
            ...(selected === "origins" ? selectedItemStyle : {}),
            color: selected === "origins" ? "#1D4ED8" : "#000000",
          }}
        >
          <icons.OriginBuildingIcon
            className="origin-building-icon"
            {...({
              fill: "currentColor",
              style: { width: "24px", height: "24px", pointerEvents: "none" },
            } as any)}
          />
          <span
            className={`fml-text ${selected === "origins" ? "selected" : ""}`}
            style={{ color: selected === "origins" ? "#1D4ED8" : "#000000" }}
          >
            Origins
          </span>
        </div>
      </div>

      <div
        id="footer-multi-location-quote-id"
        className="fml-quote-wrapper"
        role="button"
        tabIndex={0}
        onClick={(e) => handleSelect("quote", e)}
        onKeyDown={(e) => handleKeyDown(e, "quote")}
      >
        <div
          className={`fml-quote-btn ${selected === "quote" ? "selected" : ""}`}
          style={{
            ...quoteGlassStyle,
            ...(selected === "quote" ? selectedItemStyle : {}),
          }}
        >
          <img
            src={icons.SearchMagnifyingGlass}
            alt="Quote"
            className="fml-icon"
          />
          <span
            className={`fml-text ${selected === "quote" ? "selected" : ""}`}
          >
            Quote
          </span>
        </div>
      </div>
    </div>
  );
};

export default FooterMultiLocation;
